// src/admin/adminSozluk.js
//
// TA / 3 EGO ADMİN EKRANLARININ DİL SÖZLÜĞÜ — TEK KAYNAK (2026-08-22)
//
// Katılımcı tarafı ve rapor bileşeni baştan iki dilliydi; ADMİN ekranları değildi.
// Şifre ekranı da panel de yalnız Türkçeydi ve rapor kaydın diliyle basılıyordu —
// yani Türkçe doldurulmuş bir kayıttan İngilizce rapor almanın hiçbir yolu yoktu.
// Bu dosya o boşluğu kapatır. Desen DISC'ten (somerenlabs-inv2) alınmıştır.
//
// ÜÇ AYRI "DİL" KARIŞTIRILMAMALI:
//   · arayüz dili → adminin GÖRDÜĞÜ dil (bu sözlük)
//   · kaydın dili → katılımcının envanteri doldurduğu dil (record.language)
//   · rapor dili  → basılacak raporun dili; panelden seçilir, varsayılanı ARAYÜZ dili
//
// Rapor dili varsayılanının neden "arayüz" olduğu: DISC'te önce "kaydın dili" idi.
// Arayüz İngilizce yapılıp "Raporu Aç"a basıldığında rapor Türkçe geliyordu (çünkü
// kayıtlar Türkçe doldurulmuştu). Teknik olarak doğruydu ama beklenen davranış
// değildi. Aynı düzeltme burada baştan uygulanıyor.

const SOZLUK = {
  tr: {
    // ── Şifre ekranı ────────────────────────────────────────────
    girisBaslik: "Admin Girişi",
    girisAciklama: "Bu ekran Someren Labs ekibi içindir.",
    arayuzDili: "Arayüz dili",
    sifre: "Şifre",
    gir: "Gir",
    vazgec: "Vazgeç",
    yanlisSifre: "Yanlış şifre.",

    // ── Panel ───────────────────────────────────────────────────
    panelBaslik: "TA / 3 Ego Durumu — Admin Analiz",
    geri: "Geri",
    yukleniyor: "Yükleniyor...",
    hata: "Hata",

    okunanKayit: "Okunan kayıt",
    filtrelenenKayit: "Filtrelenen kayıt",
    skoruOlanKayit: "Rapor özeti olan kayıt",
    listelenenKisi: "Listelenen kişi",

    raporDili: "Rapor dili",
    arayuzIleAyni: "Arayüzle aynı",
    kaydinDili: "Kaydın dili",

    baskinDagilim: "Baskın Ego Dağılımı",
    dengeKirilim: "Ego Dengesi Kırılımı",
    jenerasyonKirilimi: "Jenerasyon Kırılımı",
    rolKirilimi: "Rol Seviyesi Kırılımı",

    kisiListesi: (n) => `Kişi Listesi — ${n} kayıt`,
    sayfa: "Sayfa",
    sayfaBilgi: (bas, son, top) => `${bas}–${son} / ${top}`,
    sutunTarih: "Tarih",
    sutunSure: "Süre",
    sutunKatilimci: "Katılımcı",
    sutunSirketTakim: "Şirket / Takım",
    sutunJenerasyon: "Jenerasyon",
    sutunRol: "Rol",
    sutunBaskin: "Baskın Ego",
    sutunDenge: "Denge Tipi",
    sutunIslem: "İşlem",
    raporuAc: "Raporu Aç",

    secilenKisiRaporu: "Seçilen Kişi Raporu",
    kapat: "Kapat",
    pdfYazdir: "PDF / Yazdır",

    // ── Filtreler ───────────────────────────────────────────────
    filtreler: "Filtreler",
    veriYok: "Veri yok",
    raporOzetiYok: "Rapor özeti yok",
    kapsam: "Kapsam",
    sonNKayit: (n) => `Son ${n} kayıt`,
    tumKayitlar: "Tüm kayıtlar",
    sirket: "Şirket",
    tumu: "Tümü",
    tumSirketler: "Tüm şirketler",
    tarih: "Tarih",
    tumZamanlar: "Tüm zamanlar",
    sonNGun: (n) => `Son ${n} gün`,
    jenerasyon: "Jenerasyon",
    tumJenerasyonlar: "Tüm jenerasyonlar",
    rol: "Rol",
    tumRoller: "Tüm roller",
    ara: "Ara",
    araIpucu: "İsim, şirket, takım…",

    // ── Etiketler ───────────────────────────────────────────────
    belirtilmedi: "Belirtilmedi",
    katilimci: "Katılımcı",
    egolar: { parent: "Ebeveyn Ego", adult: "Yetişkin Ego", child: "Çocuk Ego" },
    jenerasyonlar: {
      before_1965: "1964 ve öncesi",
      gen_x_1965_1980: "1965–1980",
      gen_y_1981_1996: "1981–1996",
      gen_z_1997_2012: "1997–2012",
    },
    roller: {
      executive: "Üst Yönetim / C-Level / Genel Müdür",
      director: "Direktör / Fonksiyon Lideri",
      manager: "Müdür",
      team_leader: "Takım Lideri / Supervisor",
      specialist: "Uzman / Bireysel Katkı Sağlayan",
      operations: "Operasyon / Saha Ekibi",
      student: "Öğrenci",
      other: "Diğer",
    },
  },

  en: {
    girisBaslik: "Admin Login",
    girisAciklama: "This screen is for the Someren Labs team.",
    arayuzDili: "Interface language",
    sifre: "Password",
    gir: "Enter",
    vazgec: "Cancel",
    yanlisSifre: "Wrong password.",

    panelBaslik: "TA / 3 Ego States — Admin Analysis",
    geri: "Back",
    yukleniyor: "Loading...",
    hata: "Error",

    okunanKayit: "Records read",
    filtrelenenKayit: "Filtered records",
    skoruOlanKayit: "Records with a report summary",
    listelenenKisi: "People listed",

    raporDili: "Report language",
    arayuzIleAyni: "Same as interface",
    kaydinDili: "The record's own language",

    baskinDagilim: "Dominant Ego Distribution",
    dengeKirilim: "Ego Balance Breakdown",
    jenerasyonKirilimi: "Generation Breakdown",
    rolKirilimi: "Role Level Breakdown",

    kisiListesi: (n) => `People — ${n} records`,
    sayfa: "Page",
    sayfaBilgi: (bas, son, top) => `${bas}–${son} of ${top}`,
    sutunTarih: "Date",
    sutunSure: "Time",
    sutunKatilimci: "Participant",
    sutunSirketTakim: "Company / Team",
    sutunJenerasyon: "Generation",
    sutunRol: "Role",
    sutunBaskin: "Dominant Ego",
    sutunDenge: "Balance Type",
    sutunIslem: "Action",
    raporuAc: "Open report",

    secilenKisiRaporu: "Selected Person's Report",
    kapat: "Close",
    pdfYazdir: "PDF / Print",

    filtreler: "Filters",
    veriYok: "No data",
    raporOzetiYok: "No report summary",
    kapsam: "Scope",
    sonNKayit: (n) => `Last ${n} records`,
    tumKayitlar: "All records",
    sirket: "Company",
    tumu: "All",
    tumSirketler: "All companies",
    tarih: "Date",
    tumZamanlar: "All time",
    sonNGun: (n) => `Last ${n} days`,
    jenerasyon: "Generation",
    tumJenerasyonlar: "All generations",
    rol: "Role",
    tumRoller: "All roles",
    ara: "Search",
    araIpucu: "Name, company, team…",

    belirtilmedi: "Not stated",
    katilimci: "Participant",
    egolar: { parent: "Parent Ego", adult: "Adult Ego", child: "Child Ego" },
    jenerasyonlar: {
      before_1965: "1964 and earlier",
      gen_x_1965_1980: "1965–1980",
      gen_y_1981_1996: "1981–1996",
      gen_z_1997_2012: "1997–2012",
    },
    roller: {
      executive: "Executive / C-Level / General Manager",
      director: "Director / Function Lead",
      manager: "Manager",
      team_leader: "Team Leader / Supervisor",
      specialist: "Specialist / Individual Contributor",
      operations: "Operations / Field Team",
      student: "Student",
      other: "Other",
    },
  },
};

export function getAdminText(lang = "tr") {
  return SOZLUK[lang] || SOZLUK.tr;
}

/**
 * Basılacak raporun dilini seçer.
 *
 * Seçenekler: "arayuz" (varsayılan) · "kayit" · "tr" · "en"
 * DISC'teki raporDiliSec() ile birebir aynı mantık — iki üründe farklı davranmasın.
 */
export function raporDiliSec(record, secim, arayuzDili) {
  if (secim === "tr" || secim === "en") return secim;
  if (secim === "kayit") return record?.language === "en" ? "en" : "tr";
  return arayuzDili === "en" ? "en" : "tr"; // "arayuz"
}
